import { Loader2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../../../components/ui/table";
import { Checkbox } from "../../../../../components/ui/checkbox";
import { OptroControlSummary } from "../../../../../models/audit/optroSync";
import { SelectControlRow } from "./SelectControlRow";

interface SelectControlsTableProps {
  controls: OptroControlSummary[];
  isSelected: (externalRef: string) => boolean;
  onToggle: (control: OptroControlSummary) => void;
  loadingMore: boolean;
  lastRowRef: (node: HTMLTableRowElement | null) => void;
  // Header select-all: selects every control matching the current
  // search/filters (fetching unloaded pages), not just the visible rows.
  headerChecked: boolean | "indeterminate";
  onToggleAll: () => void;
  selectingAll: boolean;
}

export const SelectControlsTable = ({
  controls,
  isSelected,
  onToggle,
  loadingMore,
  lastRowRef,
  headerChecked,
  onToggleAll,
  selectingAll,
}: SelectControlsTableProps) => {
  if (controls.length === 0) {
    return (
      <div className="py-16 text-center text-sm text-stone-500">
        No controls match your search.
      </div>
    );
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead className="w-10">
            {selectingAll ? (
              <Loader2 className="h-4 w-4 animate-spin text-stone-400" />
            ) : (
              <Checkbox
                checked={headerChecked}
                onCheckedChange={onToggleAll}
                aria-label="Select all matching controls"
              />
            )}
          </TableHead>
          <TableHead>Control</TableHead>
          <TableHead>Process</TableHead>
          <TableHead>Owner</TableHead>
          <TableHead>Frequency</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {controls.map((control, index) => (
          <SelectControlRow
            key={control.externalRef}
            control={control}
            checked={isSelected(control.externalRef)}
            onToggle={onToggle}
            ref={index === controls.length - 1 ? lastRowRef : undefined}
          />
        ))}
        {loadingMore && (
          <TableRow>
            <TableCell colSpan={5} className="py-4 text-center">
              <Loader2 className="mx-auto h-4 w-4 animate-spin text-stone-400" />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
